// src/App.js
import React, { useState } from 'react';
import BarraProgresso from './components/BarraProgresso';
import EtapaIdentificacao from './etapas/EtapaIdentificacao';
import EtapaDadosCliente from './etapas/EtapaDadosCliente';
import EtapaTipoServico from './etapas/EtapaTipoServico';
import EtapaDetalhesImportantes from './etapas/EtapaDetalhesImportantes';
import EtapaProdutos from './etapas/EtapaProdutos';
import EtapaContrato from './etapas/EtapaTermo';
import EtapaConclusao from './etapas/EtapaConclusao';

function App() {
  const [etapaAtual, setEtapaAtual] = useState(0);
  const [dados, setDados] = useState({});

  const avancar = () => setEtapaAtual((prev) => prev + 1);
  const voltar = () => setEtapaAtual((prev) => prev - 1);

  const etapas = [
    <EtapaIdentificacao onNext={avancar} setDados={setDados} dados={dados} />,
    <EtapaDadosCliente onNext={avancar} onBack={voltar} setDados={setDados} dados={dados} />,
    <EtapaTipoServico onNext={avancar} onBack={voltar} setDados={setDados} dados={dados} />,
    <EtapaDetalhesImportantes onNext={avancar} onBack={voltar} setDados={setDados} dados={dados} />,
    <EtapaProdutos onNext={avancar} onBack={voltar} setDados={setDados} dados={dados} />,
    <EtapaContrato onNext={avancar} onBack={voltar} setDados={setDados} dados={dados} />,
    <EtapaConclusao onBack={voltar} setDados={setDados} dados={dados} reiniciar={setEtapaAtual} />,
  ];

  return (
    <div className="container py-4">
      <h2 className="text-center mb-4">Solicitação de Orçamento</h2>
      <BarraProgresso etapaAtual={etapaAtual} />
      {etapas[etapaAtual]}
    </div>
  );
}

export default App;
